(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-alternatives-products"] && !Shopify.designMode) return;
  try {
    /* oss alternative products */
  class OssAlternative extends HTMLElement {
    constructor() {
      super();
      console.log('OssAlternative constructor');
      setTimeout(() => {
        document.addEventListener('variant:changed', (e) => {
          const variant = e.detail.variant;
          console.log(variant, variant.available === true);
          if (variant.available) {
            this.classList.remove('oss-alternative--show');
          } else {
            this.classList.add('oss-alternative--show');
          }
        });
      }, 1000);
    }
  }

  if (!customElements.get('oss-alternative')) {
    window.customElements.define('oss-alternative', OssAlternative);
  }
  /* oss alternative products END */
  } catch(e) { console.error(e); }
})();

})();
